const __DEV__ = false;

import _typeof from '@babel/runtime/helpers/typeof';

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var isNumber = function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
};
var isFunction = function isFunction(value) {
  return value instanceof Function;
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var isArray = function isArray(value) {
  return (
    Boolean(value) && _typeof(value) === 'object' && (value === null || value === void 0 ? void 0 : value.constructor) === Array
  );
};
var boolOrBoolString = function boolOrBoolString(value) {
  if (value === 'true') return true;
  if (isBoolean(value)) return value;
  return false;
};
var isEmpty = function isEmpty(obj) {
  if (_typeof(obj) === 'object' && obj !== null) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
};

export { boolOrBoolString, isArray, isBoolean, isEmpty, isFunction, isNumber, isString };
//# sourceMappingURL=check-type.js.map
